import React from 'react'

interface CalloutProps {
  kind: 'info' | 'warning' | 'tip'
  children: React.ReactNode
}

export default function Callout({ kind, children }: CalloutProps) {
  return (
    <aside className={`callout callout--${kind}`}>
      {children}
    </aside>
  )
}
